module.exports = __webpack_public_path__ + "c17a506daebb2fb2765111898c228e97.png";